import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import GradientButton from "app/pages/sales-intelligence/modules/ai-agent/components/GradientButton/GradientButton";
import signalRecommenderI18nKeys from "app/pages/sales-intelligence/modules/signal-recommender/utils/i18n";
import { canAccessSignalAnalysis } from "app/pages/sales-intelligence/modules/signal-recommender/utils/signalAnalysisAccess";
import manageSignalsPageTrackingService from "app/pages/sales-intelligence/pages/manage-signals/services/tracking";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

export const AnalyzeSignalsFromDealsButton = (): ReactElement | null => {
    const { translate } = useTranslate();

    // Reads the same predicate the route gate does, so the CTA cannot offer a page its owner is
    // redirected away from.
    if (!canAccessSignalAnalysis()) {
        return null;
    }

    const handleClick = (): void => {
        manageSignalsPageTrackingService.trackAnalyzeSignalsFromDealsClick();
        void siNavigator.goToSignalAnalysisManagementPage();
    };

    return (
        <GradientButton
            dataAutomation="account-signals-analyze-from-deals"
            variant="analyze"
            onClick={handleClick}
        >
            {translate(signalRecommenderI18nKeys.button.analyzeSignalsFromDeals)}
        </GradientButton>
    );
};
